import { render, staticRenderFns } from "./BeefCattleList.vue?vue&type=template&id=90b911aa&scoped=true"
import script from "./BeefCattleList.vue?vue&type=script&lang=js"
export * from "./BeefCattleList.vue?vue&type=script&lang=js"
import style0 from "./BeefCattleList.vue?vue&type=style&index=0&id=90b911aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b911aa",
  null
  
)

export default component.exports